import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Add, Edit, Delete, PhotoCamera } from "@material-ui/icons";
import api from "../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    modalImgWrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: theme.spacing(2),
      width: 120,
      height: 120,
      cursor: "pointer",
    },
    cameraButton: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "rgba(255,255,255,0.85)",
      borderRadius: "50%",
      width: 44,
      height: 44,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid #e5e7eb",
      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
      zIndex: 2,
      transition: "background 0.2s, box-shadow 0.2s",
      cursor: "pointer",
      '&:hover': {
        background: "#f3f4f6",
        boxShadow: "0 4px 16px rgba(0,0,0,0.13)",
      },
    },
  container: {
    backgroundColor: "#f9fafb",
    padding: theme.spacing(4),
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(7),
    },
  },

  // 🔹 Cabeçalho igual ao Cardápio
  tituloBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(4.5),
    marginBottom: theme.spacing(4),
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: theme.spacing(2.5, 3),
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1),
      padding: theme.spacing(1.5, 2),
    },
  },
  tituloTexto: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: "#111827",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05rem",
      justifyContent: "flex-start",
      gap: theme.spacing(1),
    },
  },
  botaoNovo: {
    backgroundColor: "#16a34a",
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    padding: theme.spacing(1, 3),
    boxShadow: "0 3px 8px rgba(22,163,74,0.3)",
    "&:hover": {
      backgroundColor: "#15803d",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: theme.spacing(0.6, 1.5),
      fontSize: "0.95rem",
      borderRadius: 8,
    },
  },

  // 🔹 Cards de produto
  card: {
    padding: theme.spacing(2),
    borderRadius: 16,
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
    backgroundColor: "#fff",
    maxWidth: 480,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      padding: theme.spacing(1.25),
      borderRadius: 12,
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.5),
    },
  },
  produtoImg: {
    width: 72,
    height: 72,
    objectFit: "cover",
    borderRadius: "50%",
    background: "#f3f4f6",
    border: "2px solid #e5e7eb",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    display: "block",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      margin: `0 auto ${theme.spacing(2)}px auto`,
      width: 64,
      height: 64,
      marginBottom: theme.spacing(2.5), // aumenta o espaço abaixo da imagem
    },
  },
  produtoImgBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 72,
    [theme.breakpoints.down("sm")]: {
      minWidth: 0,
      marginBottom: theme.spacing(1),
    },
  },
  modalImgBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  modalImg: {
    width: 110,
    height: 110,
    objectFit: "cover",
    borderRadius: "50%",
    background: "#f3f4f6",
    border: "2.5px solid #e5e7eb",
    boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
    marginBottom: theme.spacing(1.5),
  },
  title: {
    fontWeight: 600,
    color: "#111827",
    fontSize: "1.05rem",
  },
  price: {
    color: "#16a34a",
    fontWeight: 600,
    marginTop: 4,
  },
  obs: {
    fontStyle: "italic",
    color: "#6b7280",
  },
  buttons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  listaProdutos: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(2),
    "& > *": {
      margin: theme.spacing(1.5),
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
      "& > *": {
        margin: 0,
      },
    },
  },

  // 🔹 Modal igual ao Cardápio
  dialogPaper: {
    borderRadius: 12,
    backgroundColor: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
  },
  dialogTitle: {
    fontWeight: 700,
    color: "#111827",
    padding: theme.spacing(3),
    paddingBottom: 0,
  },
  campo: {
    marginBottom: theme.spacing(2.5),
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: "#f9fafb",
      "& fieldset": {
        borderColor: "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: "#2563eb",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2563eb",
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1.5),
    },
  },
  botoes: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 2),
      justifyContent: "space-between",
    },
  },
  botaoSalvar: {
    backgroundColor: "#16a34a",
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    marginLeft: theme.spacing(1.5),
    "&:hover": {
      backgroundColor: "#15803d",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
    },
  },
  botaoCancelar: {
    backgroundColor: "#ef4444",
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 10,
    "&:hover": {
      backgroundColor: "#dc2626",
    },
  },
}));

export default function Produtos() {
  const classes = useStyles();
  const [produtos, setProdutos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [produtoAtual, setProdutoAtual] = useState({
    id: null,
    nome: "",
    descricao: "",
    preco: "",
    observacoes: "",
    fotoUrl: null, // url da imagem
  });
  const [previewFoto, setPreviewFoto] = useState(null);
  const [fotoFile, setFotoFile] = useState(null);
  const fileInputRef = useRef();

  // 📦 Carregar produtos
  const carregarProdutos = async () => {
    try {
      const { data } = await api.get("/produtos");
      setProdutos(data.data || []);
    } catch {
      toast.error("Erro ao carregar produtos");
    }
  };

  useEffect(() => {
    carregarProdutos();
  }, []);

  // ✏️ Editar produto
  const editarProduto = (produto) => {
    setProdutoAtual({ ...produto, fotoUrl: produto.fotoUrl || null });
    setPreviewFoto(produto.fotoUrl || null);
    setEditando(true);
    setOpenModal(true);
  };

  // ➕ Novo produto
  const novoProduto = () => {
    setProdutoAtual({ id: null, nome: "", descricao: "", preco: "", observacoes: "", fotoUrl: null });
    setPreviewFoto(null);
    setEditando(false);
    setOpenModal(true);
  };

  // 💾 Salvar produto
  const salvarProduto = async () => {
    if (!produtoAtual.nome || !produtoAtual.preco) {
      toast.warning("Preencha nome e preço!");
      return;
    }
    try {
      setSalvando(true);
      let fotoUrl = produtoAtual.fotoUrl;
      // Se o usuário selecionou uma nova foto, faz upload
      if (fotoFile) {
        const formData = new FormData();
        formData.append("file", fotoFile);
        const { data } = await api.post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (data && data.url) {
          fotoUrl = data.url;
        } else {
          toast.error("Erro ao fazer upload da imagem");
          setSalvando(false);
          return;
        }
      }
      let novoProduto = {
        nome: produtoAtual.nome,
        descricao: produtoAtual.descricao,
        preco: produtoAtual.preco,
        observacoes: produtoAtual.observacoes,
        fotoUrl: fotoUrl,
      };
      if (editando && produtoAtual.id) {
        await api.put(`/produtos/${produtoAtual.id}`, novoProduto);
        toast.success("Produto atualizado!");
      } else {
        await api.post("/produtos", novoProduto);
        toast.success("Produto adicionado!");
      }
      setOpenModal(false);
      carregarProdutos();
    } catch {
      toast.error("Erro ao salvar produto");
    } finally {
      setSalvando(false);
      setFotoFile(null);
    }
  };

  // 🗑️ Excluir produto
  const excluirProduto = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este produto?")) return;
    try {
      await api.delete(`/produtos/${id}`);
      toast.info("Produto excluído!");
      carregarProdutos();
    } catch {
      toast.error("Erro ao excluir produto");
    }
  };

  return (
    <Box className={classes.container}>
      {/* 🧾 Cabeçalho estilo Cardápio */}
      <Paper elevation={0} className={classes.tituloBox}>
        <Typography className={classes.tituloTexto}>🛒 Produtos</Typography>
        <Button
          variant="contained"
          className={classes.botaoNovo}
          startIcon={<Add />}
          onClick={novoProduto}
        >
          Novo Produto
        </Button>
      </Paper>

      {/* 📋 Lista de produtos */}
      {produtos.length === 0 ? (
        <Typography color="textSecondary" align="center">
          Nenhum produto cadastrado.
        </Typography>
      ) : (
        <Box className={classes.listaProdutos}>
          {produtos.map((p) => (
            <Paper key={p.id} className={classes.card}>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                {/* Imagem do produto */}
                <Box className={classes.produtoImgBox}>
                  <img
                    src={p.fotoUrl || "https://via.placeholder.com/72x72?text=Foto"}
                    alt={p.nome}
                    className={classes.produtoImg}
                  />
                </Box>
                <Box flex={1} minWidth={0}>
                  <Typography className={classes.title}>{p.nome}</Typography>
                  {p.descricao && (
                    <Typography variant="body2" color="textSecondary">
                      {p.descricao}
                    </Typography>
                  )}
                  <Typography className={classes.price}>
                    R$ {Number(p.preco).toFixed(2)}
                  </Typography>
                  {p.observacoes && (
                    <Typography variant="body2" className={classes.obs}>
                      {p.observacoes}
                    </Typography>
                  )}
                </Box>
                <Box className={classes.buttons}>
                  <IconButton onClick={() => editarProduto(p)} color="primary">
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => excluirProduto(p.id)} color="secondary">
                    <Delete />
                  </IconButton>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      )}

      {/* 🪟 Modal de Novo/Editar */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        fullWidth
        maxWidth="sm"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          {editando ? "✏️ Editar Produto" : "🆕 Novo Produto"}
        </DialogTitle>

        <DialogContent>
          <Box mt={1.5}>
            {/* Upload de foto */}
            <Box className={classes.modalImgBox}>
              <div
                className={classes.modalImgWrapper}
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                title={previewFoto ? "Trocar foto" : "Adicionar foto"}
              >
                <img
                  src={previewFoto || "https://via.placeholder.com/110x110?text=Foto"}
                  alt="Preview"
                  className={classes.modalImg}
                  style={{ filter: 'brightness(0.93)' }}
                />
                <span className={classes.cameraButton}>
                  <PhotoCamera style={{ color: '#2563eb', fontSize: 26 }} />
                </span>
                <input
                  accept="image/*"
                  type="file"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={e => {
                    const file = e.target.files[0];
                    if (file) {
                      setFotoFile(file);
                      const reader = new FileReader();
                      reader.onload = ev => setPreviewFoto(ev.target.result);
                      reader.readAsDataURL(file);
                    }
                  }}
                />
              </div>
              {previewFoto && (
                <Button
                  variant="text"
                  color="secondary"
                  onClick={() => {
                    setPreviewFoto(null);
                    setFotoFile(null);
                    setProdutoAtual((prev) => ({ ...prev, fotoUrl: null }));
                    if (fileInputRef.current) fileInputRef.current.value = null;
                  }}
                  style={{ marginTop: 8 }}
                >
                  Remover
                </Button>
              )}
            </Box>

            <TextField
              label="Nome do Produto"
              fullWidth
              variant="outlined"
              className={classes.campo}
              value={produtoAtual.nome}
              onChange={(e) => setProdutoAtual({ ...produtoAtual, nome: e.target.value })}
            />

            <TextField
              label="Descrição"
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              className={classes.campo}
              value={produtoAtual.descricao}
              onChange={(e) => setProdutoAtual({ ...produtoAtual, descricao: e.target.value })}
            />

            <TextField
              label="Preço (R$)"
              fullWidth
              type="number"
              variant="outlined"
              className={classes.campo}
              value={produtoAtual.preco}
              onChange={(e) => setProdutoAtual({ ...produtoAtual, preco: e.target.value })}
            />

            <TextField
              label="Observações"
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              className={classes.campo}
              value={produtoAtual.observacoes}
              onChange={(e) => setProdutoAtual({ ...produtoAtual, observacoes: e.target.value })}
            />
          </Box>
        </DialogContent>

        <DialogActions className={classes.botoes}>
          <Button
            onClick={() => setOpenModal(false)}
            className={classes.botaoCancelar}
            variant="contained"
          >
            Fechar
          </Button>
          <Button
            onClick={salvarProduto}
            className={classes.botaoSalvar}
            variant="contained"
            disabled={salvando}
          >
            {salvando ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
